import { useOnResize } from "@suse-o11y/use-on-resize";
import React from "react";

import { Collapsible } from "~/components/collapsible";
import { CollapsibleContent } from "~/components/collapsible/content";
import { CollapsibleTrigger } from "~/components/collapsible/trigger";

const RESIZE_LISTENER_DEBOUNCE_TIMER_MS = 100;

export interface TruncateMultilineProps {
	className?: string;
	lineClamp: number;
}

export const TruncateMultiline: React.FC<React.PropsWithChildren<TruncateMultilineProps>> = ({
	lineClamp,
	children,
	...props
}) => {
	const [collapsedHeight, setCollapsedHeight] = React.useState<number>();
	const [contentRef, setContentRef] = React.useState<null | HTMLDivElement>(null);
	const [expanded, setExpanded] = React.useState(false);

	useOnResize<HTMLDivElement>(
		(node) => {
			setCollapsedHeight(node.scrollHeight > node.clientHeight ? node.clientHeight : 0);
		},
		{
			node: contentRef,
			debounce: RESIZE_LISTENER_DEBOUNCE_TIMER_MS,
		},
	);

	return (
		// without || undefined the animation does not work
		<Collapsible onOpenChange={setExpanded} open={expanded || collapsedHeight === 0 || undefined} {...props}>
			<CollapsibleContent
				className="state-closed:line-clamp-(--line-clamp-count)"
				forceMount
				ref={setContentRef}
				slideDownFromHeight={collapsedHeight}
				slideDownFromOpacity={1}
				style={
					{
						"--line-clamp-count": lineClamp,
					} as React.CSSProperties
				}
			>
				{children}
			</CollapsibleContent>

			<CollapsibleTrigger className="underline hover:no-underline focus-visible:no-underline group-state-open/collapsible:hidden">
				Read more
			</CollapsibleTrigger>
		</Collapsible>
	);
};
